import z from 'zod/v3';
import { ChangedBySchema } from '../../user';
import { createPaginationSchema } from '../../common/utils/schema';
import { zIsoDateTime } from '../../common/utils/schema/zIsoDateTime';

export const DataSubjectInputSchema = z
  .object({
    id: z.number(),
    sourceNames: z.string().nullable(),
    groupId: z.number(),
    groupCode: z.string(),
    groupName: z.string(),
    systemicGroup: z.boolean(),
    code: z.string(),
    name: z.string(),
    frequencyId: z.number(),
    statusId: z.number().nullable(),
    comment: z.string().nullable(),
    loadSample: z.boolean(),
    locked: z.boolean(),
    hasActive: z.boolean(),
    dataManager: ChangedBySchema.nullable(),
    dataModifiedBy: ChangedBySchema.nullable(),
    dataModifiedAt: zIsoDateTime().nullable(),
  })
  .transform(({ locked, loadSample, ...rest }) => ({
    locked: loadSample ? locked : null,
    ...rest,
  }));

export const DataSubjectInputSchemaPageSchema = createPaginationSchema(
  DataSubjectInputSchema,
);
